import type { HTMLAttributes, ReactNode } from "react";
import "./Badge.css";

/**
 * Badge — Figma "Badge" 프리미티브.
 *
 *   tone    : red | orange | green | magenta | gray  (+ deal = AI/sale 그라데이션)
 *   variant : light | solid | outline  (deal 은 variant 무시)
 *
 * 색은 전부 src/tokens 의 --badge-* / --gradient-badge 토큰에서 온다.
 */
export type BadgeTone =
  | "red"
  | "orange"
  | "green"
  | "magenta"
  | "gray"
  | "deal";
export type BadgeVariant = "light" | "solid" | "outline";

interface BadgeOwnProps {
  tone?: BadgeTone;
  variant?: BadgeVariant;
  icon?: ReactNode;
  children?: ReactNode;
}

export type BadgeProps = BadgeOwnProps &
  Omit<HTMLAttributes<HTMLSpanElement>, keyof BadgeOwnProps>;

export function Badge({
  tone = "gray",
  variant = "light",
  icon,
  children,
  className,
  ...rest
}: BadgeProps) {
  const cls = [
    "ds-badge",
    `ds-badge--${tone}`,
    // deal 은 자체 그라데이션이라 variant 클래스를 붙이지 않는다.
    tone !== "deal" && `ds-badge--${variant}`,
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <span className={cls} {...rest}>
      {icon && <span className="ds-badge__icon">{icon}</span>}
      {children}
    </span>
  );
}

export default Badge;
